// extracted by css-extract-rspack-plugin
export default {"fallback":"EpB9Jm8x2pcHflao","visual":"fsAMHdxEDakKqJWJ","pulse":"lHS7D1Gqm9MGkyH4","text":"znrR6Wm4OGQE8hen"};